export function isDesktop() {
  if (window.innerWidth > 768) {
    return true;
  } else {
    return false;
  }
}

export function isMobile() {
  if (window.innerWidth <= 768) {
    return true;
  } else {
    return false;
  }
}

export function isHome() {
  return (
    'MonrifPolopolyUtility' in window
    && 'page_type' in window.MonrifPolopolyUtility
    && window.MonrifPolopolyUtility.page_type === 'home'
  );
}

export function isiPadOriPod() {
  var isiPad = navigator.userAgent.match(/iPad/i) != null;
  var ua = navigator.userAgent;
  var isiPad =
    /iPad/i.test(ua) ||
    /iPhone OS 3_1_2/i.test(ua) ||
    /iPhone OS 3_2_2/i.test(ua);
  return isiPad;
}

export function getCookie(cname) {
  /*
   * See:
   * https://www.w3schools.com/js/js_cookies.asp
   * https://stackoverflow.com/questions/4003823/javascript-getcookie-functions/4004010
   */
  var name = cname + "=";
  var ca = document.cookie.split(";");
  var value = ""
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      value = c.substring(name.length, c.length);
    }
  }
  try {
    // there can be quotes around cookie
    value = value.match("^\"?([^\"]*)\"?$")[1];
  } catch (error) {};
  return value;
}
